import { Button, Space, Typography, Form, Divider, Input, Tooltip, Tabs, Segmented } from "antd";
import { tt_links_hover, tt_links_inital } from "../../utils/Utils";
import { useState } from "react";
import ColourPicker from "./ColourPicker";
import StylePicker from "./StylePicker";
import Checkbox from "antd/lib/checkbox/Checkbox";
export default function LinkStyle(props) {

    const { default_link = {}, callback = () => { }, link = {}, data = [], saveNew = () => { }, save = () => { }, is_new = false, is_edit = false, close = () => { } } = props;
    const { fonts = [], text_styles = [], colours = [] } = data;
    const [hover, setHover] = useState(false);

    // Button destructure
    const {
        id = 1,
        name = "",
        init_colour = 0,
        init_style = 1,
        init_underline = false,
        hover_colour = 0,
        hover_style = 1,
        hover_underline = false,

    } = link;


    const StyleLinkForm = (props) => {

        const { callback = () => { }, id = 0, is_new = true, close = () => { }, save = () => { }, name = "" } = props;
        // Save name + activate button (if not activated)
        const saveName = (_f) => {

            if (is_new) {
                saveNew(_f.name, { ...default_link })
            } else {
                save(id, _f.name, ["name"], is_new);
            }

            close();
            callback(id);
        }


        return (
            <>
                <div key={id} style={{ "padding": "20px" }}>
                    <Typography.Title level={5}>{(is_new) ? "New" : "Edit"} Link</Typography.Title>
                    <Divider style={{ "margin": "15px 0px" }} dashed />
                    <Form onFinish={(_f) => saveName(_f)} layout="vertical">
                        <Form.Item name="id" initialValue={id} noStyle>
                            <Input hidden />
                        </Form.Item>
                        <Form.Item initialValue={(is_new) ? "" : name} rules={[{ required: true, message: "Name is required" }]} label="Name" name="name">
                            <Input maxLength={20} placeholder="Link style name..." />
                        </Form.Item>
                        <div className="float-flex">
                            <div>&nbsp;</div>
                            <Button htmlType="submit" type="primary">Save</Button>
                        </div>
                    </Form>
                </div>
            </>
        )
    }


    // NEW AND EDIT FORM
    if (is_new || is_edit) {
        return (
            <>
                <StyleLinkForm callback={callback} save={save} close={close} id={id} name={name} is_new={is_new} />
            </>
        )
    }

    const drawPreview = () => {
        return (
            <div className="label-border" style={{ "textAlign": "center" }}>
                <div style={{ "height": "25px", "overflow": "hidden" }}>
                    <a href="#" className={"bm-lnk-" + id}>{name}</a>
                </div>
            </div>
        )
    }


    const tab_items = [
        {
            label: <small>INITIAL</small>, key: '0', children: (
                <div>
                    {/* INITIAL */}
                    <Divider orientationMargin={0} plain className="sublabel" orientation="left">INITIAL</Divider>

                    {/* COLOR */}
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">COLOUR</Divider>
                    <ColourPicker allow_none value={init_colour} onChange={(_v) => save(id, _v, ["init_colour"])} colours={colours} />
                    <div className="shim" />

                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">STYLE</Divider>
                    <Space>
                        <div style={{ "width": "180px" }}><StylePicker value={init_style} onChange={(_v) => save(id, _v, ["init_style"])} styles={text_styles} /></div>
                        <Checkbox checked={init_underline} onChange={(e) => save(id, e.target.checked, ["init_underline"])} ><small>Underline?</small></Checkbox>
                    </Space>
                    <div className="shim" />
                </div>
            )
        }, // remember to pass the key prop
        {
            label: <small>HOVER / FOCUS</small>, key: '1', children: (
                <div>
                    {/* HOVER */}
                    <Divider orientationMargin={0} plain className="sublabel" orientation="left">HOVER</Divider>

                    {/* COLOR */}
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">COLOUR</Divider>
                    <ColourPicker allow_none value={hover_colour} onChange={(_v) => save(id, _v, ["hover_colour"])} colours={colours} />
                    <div className="shim" />

                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">STYLE</Divider>
                    <Space>
                        <div style={{ "width": "180px" }}><StylePicker value={hover_style} onChange={(_v) => save(id, _v, ["hover_style"])} styles={text_styles} /></div>
                        <Checkbox checked={hover_underline} onChange={(e) => save(id, e.target.checked, ["hover_underline"])} ><small>Underline?</small></Checkbox>
                    </Space>
                    <div className="shim" />


                </div>
            )
        },
    ];



    return (
        <>

            {drawPreview()}
            <div className="shim" /><div className="shim" />
            <Segmented value={hover} onChange={(e) => setHover(e)} style={{ "fontSize": "11px" }} block options={
                [
                    {
                        label: <Tooltip title={tt_links_inital}>Initial</Tooltip>,
                        value: false
                    }, {
                        label: <Tooltip title={tt_links_hover}>Hover / Focus</Tooltip>,
                        value: true
                    }
                ]
            } />

            <Tabs activeKey={(hover) ? "1" : "0"} className="button_tabs" items={tab_items} size="small" />












        </>
    )

}